module.exports = __webpack_public_path__ + "img/ic_32_profile_sports.3446a0d0.svg";